import "../styles/globals.css";
import "../styles/PronAnalysisSection.css";
import "../styles/interviews/Review_NavBar.css";
import "../styles/interviews/Review_Panel_AntiCheat.css";
import "../styles/interviews/Review_Panel_Assessment.css";
import "../styles/interviews/Review_Panel_Performance.css";
import "../styles/interviews/Review_Panel_PronAssess.css";
import "../styles/interviews/Review_Panel_TalkPoints.css";
import "video.js/dist/video-js.css";
import "../styles/candidates/HSLabel.css";
import "../styles/interviews/Review_Panel_Video.css";
import "../styles/interviews/TalkingPointsSection.css";
import "../styles/interviews/main.css";
import "../styles/login.css";
import "../styles/base.css";

import { NextPage, NextComponentType, NextPageContext } from "next";
// import { FpjsProvider } from "@fingerprintjs/fingerprintjs-pro-react";

import Head from "next/head";
import { AppProps } from "next/app";
import { AuthProvider } from "@/hooks/useAuth";
// import { TablaProvider } from "@/lib/Tabla";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

type NextPageWithLayout<P = {}, IP = P> = NextPage<P, IP> & {
  needAuth: boolean;
};

export type NextComponentWithLayout = NextComponentType<
  NextPageContext,
  any,
  {}
> &
  Partial<NextPageWithLayout>;

type ExtendedAppProps<P = {}> = AppProps<P> & {
  Component: NextComponentWithLayout;
  pageProps: any;
};

function MyApp({ Component, pageProps }: ExtendedAppProps) {
  const { needAuth } = Component;
  return (
    // <FpjsProvider
    //   loadOptions={{
    //     apiKey: "AyU2JdvVuX6jxTxdsTz1",
    //     region: "ap",
    //   }}
    // >
    <>
      {needAuth === false ? (
        <AuthProvider disablePreAuth={true}>
          {/* <TablaProvider> */}
          <Head>
            <title>
              {" "}
              Dashboard | HKBU | powered by Career
              Hackers
            </title>
          </Head>
          <Component {...pageProps} />
          <ToastContainer
            position="top-right"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            toastStyle={{
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '500',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              border: '1px solid rgba(0, 0, 0, 0.1)'
            }}
            progressStyle={{
              background: 'linear-gradient(90deg, #4f46e5, #7c3aed)'
            }}
          />
          {/* </TablaProvider> */}
        </AuthProvider>
      ) : (
        <AuthProvider disablePreAuth={false}>
          {/* <TablaProvider> */}
          <Head>
            <title>
              {" "}
              Dashboard | HKBU | powered by Career
              Hackers
            </title>
          </Head>
          <Component {...pageProps} />
          <ToastContainer
            position="top-right"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            toastStyle={{
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '500',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
              border: '1px solid rgba(0, 0, 0, 0.1)'
            }}
            progressStyle={{
              background: 'linear-gradient(90deg, #4f46e5, #7c3aed)'
            }}
          />
          {/* </TablaProvider> */}
        </AuthProvider>
      )}
    </>
    // </FpjsProvider>
  );
}

export default MyApp;
